import { useQueryStates } from 'src/core/api/hooks/useQueryStates';
import { reshapeQueryState, type QueryState } from 'src/core/api/queryState';
import { mapQueryResultToQueryState } from 'src/core/api/utils/queryState';

import { type BudgetDefinition } from './budgetDefinition';
import { useBudgetDimensionData } from './useBudgetDimensionData';
import { useGetBudgetDefinition } from './useGetBudgetDefinition';
import { type DimensionData } from '../models/dimensionData';

export type BudgetWithDimensionData = {
  budget: BudgetDefinition;
  dimensionData: DimensionData;
};

export const useBudgetWithDimensionData = (
  budgetId: string,
): QueryState<BudgetWithDimensionData> => {
  const budgetQueryState = mapQueryResultToQueryState(
    useGetBudgetDefinition(budgetId),
  );
  const dimensionDataQueryState = useBudgetDimensionData(
    reshapeQueryState(budgetQueryState, ({ definition }) => definition),
  );
  return useQueryStates({
    states: {
      budget: budgetQueryState,
      dimensionData: dimensionDataQueryState,
    },
  });
};
